import { render, staticRenderFns } from "./alertChart.vue?vue&type=template&id=35a8f301&scoped=true"
import script from "./alertChart.vue?vue&type=script&lang=js"
export * from "./alertChart.vue?vue&type=script&lang=js"
import style0 from "./alertChart.vue?vue&type=style&index=0&id=35a8f301&lang=scss&scoped=true"
import style1 from "./alertChart.vue?vue&type=style&index=1&id=35a8f301&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a8f301",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/3e17078e833b83b1/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35a8f301')) {
      api.createRecord('35a8f301', component.options)
    } else {
      api.reload('35a8f301', component.options)
    }
    module.hot.accept("./alertChart.vue?vue&type=template&id=35a8f301&scoped=true", function () {
      api.rerender('35a8f301', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/assurance/components/moi-alert-chart/alertChart.vue"
export default component.exports